import qs from "qs";

const cancelConfirmPage = () => {
  const query = qs.stringify({
    populate: ['image']
  });
  return '/cancel-confirm-page?' + query;
};

export default cancelConfirmPage;
